import AbstractItemTemplate from "../AbstractItemTemplate.js";

/**
 * Abstract template row.
 *
 * @abstract
 * @param {groupRow} [spec.parent] - Parent group row if the row is nested.
 */
export default class AbstractRowTemplate extends AbstractItemTemplate {
	constructor({ parent } = {}) {
		super(...arguments);

		// This avoids circular references when serializing this as JSON
		// as it is done in Storybook
		Object.defineProperty(this, "_parent", {
			enumerable: false,
			value: parent,
			writable: true,
		});
	}

	isVisibleWhenNoData() {
		return false;
	}

	setVisibleWhenNoData() {
		// nothing to do. Implemented for polymorphism with
		// AbstractValueRowTemplate.
	}

	getRows() {
		return [];
	}

	getAllRows() {
		const rows = this.getRows().slice();

		this.getRows().forEach((row) => {
			// eslint-disable-next-line no-shadow -- bad practice, we should fix this
			row.getAllRows().forEach((row) => {
				rows.push(row);
			});
		});

		return rows;
	}

	getAllSimilarItems({ report }) {
		return report.getAllRows();
	}

	getParent() {
		return this._parent || super.getParent();
	}

	setParent(parent) {
		this._parent = parent;
	}

	/**
	 * Gets all predecessors of the row except the report template.
	 */
	getPredecessors() {
		if (!this._parent || this._parent === this._reportTemplate) {
			return [];
		}

		const predecessorsOfMyParent = this._parent.getPredecessors();
		return predecessorsOfMyParent.concat(this._parent);
	}

	isRow() {
		return true;
	}

	isAccountGroupRowTemplate() {
		return false;
	}

	isVisible() {
		return this.getParent().isVisible() && super.isVisible();
	}

	isAccountGroupRow() {
		return false;
	}

	isAccountIntervalGroupRow() {
		return false;
	}

	isRepeatingRowTemplate() {
		return false;
	}

	isTopLevel() {
		return this.getDepth() === 1;
	}

	getDepth() {
		return this.getParent().getDepth() + 1;
	}

	canAdd(_row) {
		return this.canHaveChildren();
	}

	canBeAddedToGroupRow(_group) {
		return true;
	}

	canBeRepeated() {
		return true;
	}

	isRepeated() {
		const parent = this.getParent();
		return (
			parent && (parent.isRepeatingRowTemplate() || parent.isRepeated())
		);
	}

	addTo(parent, sibling) {
		return parent.addRow(this, sibling);
	}

	removeFrom(parent) {
		return parent.removeRow(this);
	}

	removeRow() {}

	accept(visitor) {
		return visitor.visitAbstractRowTemplate(this);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.rowType = this.getType();

		properties.masterVisibilityRowTemplateId =
			this._masterVisibilityTemplateId;

		return properties;
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(data, context);

		data.masterVisibilityTemplateId = data.masterVisibilityRowTemplateId;
	}
}
